import { defineMessages } from 'react-intl';

export default defineMessages({
  MAX_LENGTH: {
    defaultMessage: '{currentLength, number} / {maxLength, number}',
  },
});
